import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

// ================================
// APP SETTINGS APIS (FormData-based)
// Controller: Appcon.php
// ================================

// 1) Get App Settings
export async function getAppSettings(admin_id) {
  try {
    const fd = new FormData();
    fd.append("admin_id", admin_id);

    const res = await axios.post(`${apiBaseUrl}appset/get_app_settings`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Request Failed" };
  }
}

// 2) Save App Settings
export async function saveAppSettings(payload) {
  try {
    const fd = new FormData();
    fd.append("admin_id", payload.admin_id || "");

    fd.append("withdrawal_commission", payload.withdrawal_commission || "");
    fd.append("deposit_charge", payload.deposit_charge || "");
    fd.append("credit_interest_rate", payload.credit_interest_rate || "");

    // optional payment gateway config
    fd.append("pg_key", payload.pg_key || "");
    fd.append("pg_secret", payload.pg_secret || "");

    const res = await axios.post(`${apiBaseUrl}appset/save_app_settings`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Request Failed" };
  }
}
